var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotReady(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 4,
    fill: "#FFF3DE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9062 8.15625V20.5312C17.9062 21.1328 17.4336 21.5625 16.875 21.5625C16.2734 21.5625 15.8438 21.1328 15.8438 20.5312V8.15625C15.8438 7.59766 16.2734 7.125 16.875 7.125C17.4336 7.125 17.9062 7.59766 17.9062 8.15625ZM16.875 26.375C16.1016 26.375 15.5 25.7734 15.5 25C15.5 24.2695 16.1016 23.625 16.875 23.625C17.6055 23.625 18.25 24.2695 18.25 25C18.25 25.7734 17.6055 26.375 16.875 26.375Z",
    fill: "#FAAF00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotReady);
export default __webpack_public_path__ + "static/media/not-ready.1779827fdb3fa1ccca63ea290b0b29b4.svg";
export { ForwardRef as ReactComponent };